module.exports = __webpack_public_path__ + "static/media/Pipeline.72525091.svg";